(() => {
  if (window.cartDrawerRecommendationsInitialized) {
    return;
  }

  window.cartDrawerRecommendationsInitialized = true;

  const getCartSectionIds = () => {
    const sectionIds = [];
    const cartItemsComponents = document.querySelectorAll('cart-items-component');

    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionIds.push(item.dataset.sectionId);
      }
    });

    return sectionIds;
  };

  const getVariantForSize = (item$, selectedSize) => {
    const sizeOptionIndexRaw = item$.dataset.sizeOptionIndex;
    const variantsRaw = item$.dataset.variants;

    if (!sizeOptionIndexRaw || !variantsRaw) {
      return null;
    }

    const sizeOptionIndex = Number(sizeOptionIndexRaw);
    if (Number.isNaN(sizeOptionIndex)) {
      return null;
    }

    const optionKey = `option${sizeOptionIndex + 1}`;

    let variants = [];
    try {
      variants = JSON.parse(variantsRaw);
    } catch (error) {
      console.error('Failed to parse recommendation variants:', error);
      return null;
    }

    const availableVariant = variants.find((variant) => variant[optionKey] === selectedSize && variant.available);
    if (availableVariant) {
      return availableVariant;
    }

    return variants.find((variant) => variant[optionKey] === selectedSize) || null;
  };

  const getVariants = (item$) => {
    const variantsRaw = item$.dataset.variants;
    if (!variantsRaw) {
      return [];
    }

    try {
      return JSON.parse(variantsRaw);
    } catch (error) {
      console.error('Failed to parse recommendation variants:', error);
      return [];
    }
  };

  const updateAddButtonState = (item$, variant) => {
    const addButton$ = item$.querySelector('[data-recommendation-add-button]');
    if (!(addButton$ instanceof HTMLButtonElement)) {
      return;
    }

    const addText = addButton$.dataset.addText || 'Agregar';
    const oosText = addButton$.dataset.oosText || 'Sin stock';
    const isAvailable = Boolean(variant?.available);

    addButton$.disabled = !isAvailable;
    addButton$.textContent = isAvailable ? addText : oosText;
  };

  const getCurrentVariant = (item$) => {
    const variantInput$ = item$.querySelector('[data-recommendation-variant-id]');
    if (!(variantInput$ instanceof HTMLInputElement)) {
      return null;
    }

    const variants = getVariants(item$);
    return variants.find((variant) => String(variant.id) === String(variantInput$.value)) || variants[0] || null;
  };

  const getSelectedSizeValue = (item$) => {
    const selectedSizeOption$ = item$.querySelector('[data-recommendation-size-option][aria-selected="true"]');
    if (selectedSizeOption$ instanceof HTMLButtonElement) {
      return selectedSizeOption$.dataset.sizeValue || selectedSizeOption$.textContent?.trim() || '';
    }
    return '';
  };

  const syncVariantFromSize = (item$) => {
    const variantInput$ = item$.querySelector('[data-recommendation-variant-id]');

    if (!(variantInput$ instanceof HTMLInputElement)) {
      updateAddButtonState(item$, getCurrentVariant(item$));
      return;
    }

    const selectedSizeValue = getSelectedSizeValue(item$);
    if (!selectedSizeValue) {
      updateAddButtonState(item$, getCurrentVariant(item$));
      return;
    }

    const selectedVariant = getVariantForSize(item$, selectedSizeValue);
    if (selectedVariant?.id) {
      variantInput$.value = selectedVariant.id;
    }

    updateAddButtonState(item$, selectedVariant || getCurrentVariant(item$));
  };

  const initializeAllItems = () => {
    const recommendationItems$ = Array.from(document.querySelectorAll('[data-cart-recommendation-item]'));

    recommendationItems$.forEach((item$) => {
      if (!(item$ instanceof HTMLElement)) {
        return;
      }

      syncVariantFromSize(item$);
    });

    const initEmbla = () => {
      const sliders$ = document.querySelectorAll('[data-recommendation-slider]');
      sliders$.forEach(slider$ => {
        if (slider$.dataset.emblaInitialized === 'true') return;
        if (typeof EmblaCarousel === 'undefined') return;

        slider$.dataset.emblaInitialized = 'true';
        
        const container$ = slider$.closest('.cart-recommendations-standalone');
        const prevButton$ = container$?.querySelector('[data-recommendation-arrow="prev"]');
        const nextButton$ = container$?.querySelector('[data-recommendation-arrow="next"]');

        if (slider$.emblaInstance) {
          slider$.emblaInstance.destroy();
        }

        const embla = EmblaCarousel(slider$, {
          loop: true,
          align: 'start',
          slidesToScroll: 1,
          containScroll: false,
          dragFree: false
        });

        slider$.emblaInstance = embla;

        if (prevButton$) {
          prevButton$.onclick = () => embla.scrollPrev();
        }

        if (nextButton$) {
          nextButton$.onclick = () => embla.scrollNext();
        }
      });
    };

    if (typeof EmblaCarousel !== 'undefined') {
      initEmbla();
    } else {
      const checkEmbla = setInterval(() => {
        if (typeof EmblaCarousel !== 'undefined') {
          clearInterval(checkEmbla);
          initEmbla();
        }
      }, 50);
    }
  };

  const refreshCartDrawer = (sections) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          data: {
            source: 'cart-drawer-recommendations',
            itemCount: 1,
            sections: sections || {},
          },
        },
      })
    );

    document.dispatchEvent(new Event('free-shipping:refresh'));
  };

  document.addEventListener('click', (event) => {
    const target$ = event.target;
    if (!(target$ instanceof Element)) {
      return;
    }

    const option$ = target$.closest('[data-recommendation-size-option]');
    if (option$ instanceof HTMLButtonElement) {
      event.preventDefault();

      if (option$.dataset.disabled === 'true') {
        return;
      }

      const picker$ = option$.closest('[data-recommendation-size-picker]');
      const item$ = option$.closest('[data-cart-recommendation-item]');
      if (!(picker$ instanceof HTMLElement) || !(item$ instanceof HTMLElement)) {
        return;
      }

      const optionsButtons$ = Array.from(picker$.querySelectorAll('[data-recommendation-size-option]'));
      optionsButtons$.forEach((otherOption$) => {
        if (otherOption$ instanceof HTMLButtonElement) {
          otherOption$.setAttribute('aria-selected', 'false');
        }
      });

      option$.setAttribute('aria-selected', 'true');
      syncVariantFromSize(item$);
      return;
    }

    const arrow$ = target$.closest('[data-recommendation-arrow]');
    if (arrow$ instanceof HTMLButtonElement) {
      event.preventDefault();
      // Arrow logic is now handled by Embla
      return;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form$ = event.target;
    if (!(form$ instanceof HTMLFormElement)) {
      return;
    }

    if (!form$.matches('[data-cart-recommendation-form]')) {
      return;
    }

    event.preventDefault();

    const variantInput$ = form$.querySelector('[data-recommendation-variant-id]');
    const submitButton$ = form$.querySelector('button[type="submit"]');

    if (!(variantInput$ instanceof HTMLInputElement) || !(submitButton$ instanceof HTMLButtonElement)) {
      return;
    }

    submitButton$.disabled = true;

    try {
      const formData = new FormData();
      formData.append('id', variantInput$.value);
      formData.append('quantity', '1');
      formData.append('sections', getCartSectionIds().join(','));

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: formData,
      });

      const responseJson = await response.json();

      if (!response.ok || responseJson.status) {
        return;
      }

      refreshCartDrawer(responseJson.sections);
    } catch (error) {
      console.error('Failed to add recommended product to cart:', error);
    } finally {
      const item$ = form$.closest('[data-cart-recommendation-item]');
      if (item$ instanceof HTMLElement) {
        syncVariantFromSize(item$);
      } else {
        submitButton$.disabled = false;
      }
    }
  });

  document.addEventListener('cart:update', () => {
    // Wait for the cart morphing to finish before initializing
    setTimeout(() => {
      initializeAllItems();
    }, 100);
  });

  initializeAllItems();
})();